import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DoctorAppBreadcrumbComponent } from './app.breadcrumb.component';
import { DoctorAppMenuComponent } from './app.menu.component';
import { DoctorAppMenuitemComponent } from './app.menuitem.component';
import { DoctorAppTopBarComponent } from './app.topbar.component';
import { PrimengModule } from 'src/app/primeng/primeng.module';
import { SharedModule } from '../../shared/shared.module';
// import { DoctorDashboardComponent } from '../doctors/doctor-dashboard/doctor-dashboard.component';
// import { OtherMedicalProfessionDashboardComponent } from '../other-medical-profession/other-medical-profession-dashboard/other-medical-profession-dashboard.component';
import { DmessageCenterComponent } from './dmessage-center/dmessage-center.component';
import { ComposeEmailComponent } from './compose-email/compose-email.component';
import { MailViewComponent } from './mail-view/mail-view.component';
import { DoctordataComponent } from './doctordata/doctordata.component';
import { ScheduleComponent } from './schedule/schedule.component';
import { MedicalProfessionDashboardComponent } from './medical-profession-dashboard/medical-profession-dashboard.component';
import { NovspecialDoctordashboardComponent } from './novspecial-doctordashboard/novspecial-doctordashboard.component';
import { DoctorvideosectionComponent } from './doctorvideosection/doctorvideosection.component';
import { UtilitiesModule } from '../../shared/utilities/utilities.module';
import { DoctorAgreementComponent } from './doctor-agreement/doctor-agreement.component';
import { EditDataComponent } from './edit-data/edit-data.component';
import { AppointmentsComponent } from './appointments/appointments.component';
import { HttpClientModule } from '@angular/common/http';
import { PatientViewModule } from '../../shared/patient-view/patient-view.module';
import { PatientProfileComponent } from './patient-profile/patient-profile.component';
import { PatientsComponent } from './patients/patients.component';
import { FetchUserListComponent } from './fetch-user-list/fetch-user-list.component';
import { ViewUserDetailsComponent } from './view-user-details/view-user-details.component';
import { UploadDocumentsMainComponent } from './upload-documents-main/upload-documents-main.component';



const COMPONENTS = [
    MedicalProfessionDashboardComponent,
    DoctorAppMenuComponent,
    DoctorAppMenuitemComponent,
    DoctorAppTopBarComponent,
    DoctorAppBreadcrumbComponent,
    DmessageCenterComponent,
    ComposeEmailComponent,
    MailViewComponent,
    DoctordataComponent,
    ScheduleComponent,
    NovspecialDoctordashboardComponent,
    DoctorvideosectionComponent,
    DoctorAgreementComponent,
    EditDataComponent,
    AppointmentsComponent,
    PatientProfileComponent,
    PatientsComponent,
    FetchUserListComponent,
    ViewUserDetailsComponent,
    UploadDocumentsMainComponent
];

@NgModule({
    declarations: COMPONENTS,
    imports: [
        CommonModule,
        PrimengModule,
        SharedModule,
        HttpClientModule,
        PatientViewModule,
        UtilitiesModule
    ],
    exports: COMPONENTS
    // providers: [
    //   DoctorDashboardComponent,
    //   OtherMedicalProfessionDashboardComponent
    // ]
})
export class MedicalProfessionSharedModule {}
